module.exports = __webpack_public_path__ + "static/media/tw.65b16b50.jpeg";